import SchoolOptionsGroupRoute from 'linced-app/routes/school-options/group';

export default class GroupRoute extends SchoolOptionsGroupRoute {
  // Reuse the school-options/group template and its controller rather than
  // duplicating them. `renderTemplate`/`render` were removed in Ember 4.0;
  // `templateName` and `controllerName` are the supported equivalents.
  templateName = 'school-options/group';
  controllerName = 'school-options/group';
}
